// From https://github.com/omsrivastava/timezones-list/blob/master/dist/timezones.json
// Based on https://en.wikipedia.org/wiki/List_of_tz_database_time_zones

export default [
  {
    label: "Asia/Singapore (GMT+08:00)",
    tzCode: "Asia/Singapore",
    name: "(GMT+08:00) Asia Singapore",
    utc: "+08:00"
  },
  {
    label: "Etc/GMT+12 (GMT-12:00)",
    tzCode: "Etc/GMT+12",
    name: "(GMT-12:00) Etc GMT+12",
    utc: "-12:00"
  },
  {
    label: "Etc/GMT+11 (GMT-11:00)",
    tzCode: "Etc/GMT+11",
    name: "(GMT-11:00) Etc GMT+11",
    utc: "-11:00"
  },
  {
    label: "Pacific/Midway (GMT-11:00)",
    tzCode: "Pacific/Midway",
    name: "(GMT-11:00) Pacific Midway",
    utc: "-11:00"
  },
  {
    label: "Pacific/Niue (GMT-11:00)",
    tzCode: "Pacific/Niue",
    name: "(GMT-11:00) Pacific Niue",
    utc: "-11:00"
  },
  {
    label: "Pacific/Pago Pago (GMT-11:00)",
    tzCode: "Pacific/Pago_Pago",
    name: "(GMT-11:00) Pacific Pago Pago",
    utc: "-11:00"
  },
  {
    label: "Etc/GMT+10 (GMT-10:00)",
    tzCode: "Etc/GMT+10",
    name: "(GMT-10:00) Etc GMT+10",
    utc: "-10:00"
  },
  {
    label: "HST (GMT-10:00)",
    tzCode: "HST",
    name: "(GMT-10:00) HST",
    utc: "-10:00"
  },
  {
    label: "Pacific/Honolulu (GMT-10:00)",
    tzCode: "Pacific/Honolulu",
    name: "(GMT-10:00) Pacific Honolulu",
    utc: "-10:00"
  },
  {
    label: "Pacific/Rarotonga (GMT-10:00)",
    tzCode: "Pacific/Rarotonga",
    name: "(GMT-10:00) Pacific Rarotonga",
    utc: "-10:00"
  },
  {
    label: "Pacific/Tahiti (GMT-10:00)",
    tzCode: "Pacific/Tahiti",
    name: "(GMT-10:00) Pacific Tahiti",
    utc: "-10:00"
  },
  {
    label: "Pacific/Marquesas (GMT-09:30)",
    tzCode: "Pacific/Marquesas",
    name: "(GMT-09:30) Pacific Marquesas",
    utc: "-09:30"
  },
  {
    label: "America/Adak (GMT-09:00)",
    tzCode: "America/Adak",
    name: "(GMT-09:00) America Adak",
    utc: "-09:00"
  },
  {
    label: "Etc/GMT+9 (GMT-09:00)",
    tzCode: "Etc/GMT+9",
    name: "(GMT-09:00) Etc GMT+9",
    utc: "-09:00"
  },
  {
    label: "Pacific/Gambier (GMT-09:00)",
    tzCode: "Pacific/Gambier",
    name: "(GMT-09:00) Pacific Gambier",
    utc: "-09:00"
  },
  {
    label: "America/Anchorage (GMT-08:00)",
    tzCode: "America/Anchorage",
    name: "(GMT-08:00) America Anchorage",
    utc: "-08:00"
  },
  {
    label: "America/Juneau (GMT-08:00)",
    tzCode: "America/Juneau",
    name: "(GMT-08:00) America Juneau",
    utc: "-08:00"
  },
  {
    label: "America/Metlakatla (GMT-08:00)",
    tzCode: "America/Metlakatla",
    name: "(GMT-08:00) America Metlakatla",
    utc: "-08:00"
  },
  {
    label: "America/Nome (GMT-08:00)",
    tzCode: "America/Nome",
    name: "(GMT-08:00) America Nome",
    utc: "-08:00"
  },
  {
    label: "America/Sitka (GMT-08:00)",
    tzCode: "America/Sitka",
    name: "(GMT-08:00) America Sitka",
    utc: "-08:00"
  },
  {
    label: "America/Yakutat (GMT-08:00)",
    tzCode: "America/Yakutat",
    name: "(GMT-08:00) America Yakutat",
    utc: "-08:00"
  },
  {
    label: "Etc/GMT+8 (GMT-08:00)",
    tzCode: "Etc/GMT+8",
    name: "(GMT-08:00) Etc GMT+8",
    utc: "-08:00"
  },
  {
    label: "Pacific/Pitcairn (GMT-08:00)",
    tzCode: "Pacific/Pitcairn",
    name: "(GMT-08:00) Pacific Pitcairn",
    utc: "-08:00"
  },
  {
    label: "America/Creston (GMT-07:00)",
    tzCode: "America/Creston",
    name: "(GMT-07:00) America Creston",
    utc: "-07:00"
  },
  {
    label: "America/Dawson (GMT-07:00)",
    tzCode: "America/Dawson",
    name: "(GMT-07:00) America Dawson",
    utc: "-07:00"
  },
  {
    label: "America/Dawson Creek (GMT-07:00)",
    tzCode: "America/Dawson_Creek",
    name: "(GMT-07:00) America Dawson Creek",
    utc: "-07:00"
  },
  {
    label: "America/Fort Nelson (GMT-07:00)",
    tzCode: "America/Fort_Nelson",
    name: "(GMT-07:00) America Fort Nelson",
    utc: "-07:00"
  },
  {
    label: "America/Hermosillo (GMT-07:00)",
    tzCode: "America/Hermosillo",
    name: "(GMT-07:00) America Hermosillo",
    utc: "-07:00"
  },
  {
    label: "America/Los Angeles (GMT-07:00)",
    tzCode: "America/Los_Angeles",
    name: "(GMT-07:00) America Los Angeles",
    utc: "-07:00"
  },
  {
    label: "America/Phoenix (GMT-07:00)",
    tzCode: "America/Phoenix",
    name: "(GMT-07:00) America Phoenix",
    utc: "-07:00"
  },
  {
    label: "America/Tijuana (GMT-07:00)",
    tzCode: "America/Tijuana",
    name: "(GMT-07:00) America Tijuana",
    utc: "-07:00"
  },
  {
    label: "America/Vancouver (GMT-07:00)",
    tzCode: "America/Vancouver",
    name: "(GMT-07:00) America Vancouver",
    utc: "-07:00"
  },
  {
    label: "America/Whitehorse (GMT-07:00)",
    tzCode: "America/Whitehorse",
    name: "(GMT-07:00) America Whitehorse",
    utc: "-07:00"
  },
  {
    label: "Etc/GMT+7 (GMT-07:00)",
    tzCode: "Etc/GMT+7",
    name: "(GMT-07:00) Etc GMT+7",
    utc: "-07:00"
  },
  {
    label: "MST (GMT-07:00)",
    tzCode: "MST",
    name: "(GMT-07:00) MST",
    utc: "-07:00"
  },
  {
    label: "PST8PDT (GMT-07:00)",
    tzCode: "PST8PDT",
    name: "(GMT-07:00) PST8PDT",
    utc: "-07:00"
  },
  {
    label: "America/Belize (GMT-06:00)",
    tzCode: "America/Belize",
    name: "(GMT-06:00) America Belize",
    utc: "-06:00"
  },
  {
    label: "America/Boise (GMT-06:00)",
    tzCode: "America/Boise",
    name: "(GMT-06:00) America Boise",
    utc: "-06:00"
  },
  {
    label: "America/Cambridge Bay (GMT-06:00)",
    tzCode: "America/Cambridge_Bay",
    name: "(GMT-06:00) America Cambridge Bay",
    utc: "-06:00"
  },
  {
    label: "America/Chihuahua (GMT-06:00)",
    tzCode: "America/Chihuahua",
    name: "(GMT-06:00) America Chihuahua",
    utc: "-06:00"
  },
  {
    label: "America/Costa Rica (GMT-06:00)",
    tzCode: "America/Costa_Rica",
    name: "(GMT-06:00) America Costa Rica",
    utc: "-06:00"
  },
  {
    label: "America/Denver (GMT-06:00)",
    tzCode: "America/Denver",
    name: "(GMT-06:00) America Denver",
    utc: "-06:00"
  },
  {
    label: "America/Edmonton (GMT-06:00)",
    tzCode: "America/Edmonton",
    name: "(GMT-06:00) America Edmonton",
    utc: "-06:00"
  },
  {
    label: "America/El Salvador (GMT-06:00)",
    tzCode: "America/El_Salvador",
    name: "(GMT-06:00) America El Salvador",
    utc: "-06:00"
  },
  {
    label: "America/Guatemala (GMT-06:00)",
    tzCode: "America/Guatemala",
    name: "(GMT-06:00) America Guatemala",
    utc: "-06:00"
  },
  {
    label: "America/Inuvik (GMT-06:00)",
    tzCode: "America/Inuvik",
    name: "(GMT-06:00) America Inuvik",
    utc: "-06:00"
  },
  {
    label: "America/Managua (GMT-06:00)",
    tzCode: "America/Managua",
    name: "(GMT-06:00) America Managua",
    utc: "-06:00"
  },
  {
    label: "America/Mazatlan (GMT-06:00)",
    tzCode: "America/Mazatlan",
    name: "(GMT-06:00) America Mazatlan",
    utc: "-06:00"
  },
  {
    label: "America/Ojinaga (GMT-06:00)",
    tzCode: "America/Ojinaga",
    name: "(GMT-06:00) America Ojinaga",
    utc: "-06:00"
  },
  {
    label: "America/Regina (GMT-06:00)",
    tzCode: "America/Regina",
    name: "(GMT-06:00) America Regina",
    utc: "-06:00"
  },
  {
    label: "America/Swift Current (GMT-06:00)",
    tzCode: "America/Swift_Current",
    name: "(GMT-06:00) America Swift Current",
    utc: "-06:00"
  },
  {
    label: "America/Tegucigalpa (GMT-06:00)",
    tzCode: "America/Tegucigalpa",
    name: "(GMT-06:00) America Tegucigalpa",
    utc: "-06:00"
  },
  {
    label: "America/Yellowknife (GMT-06:00)",
    tzCode: "America/Yellowknife",
    name: "(GMT-06:00) America Yellowknife",
    utc: "-06:00"
  },
  {
    label: "Etc/GMT+6 (GMT-06:00)",
    tzCode: "Etc/GMT+6",
    name: "(GMT-06:00) Etc GMT+6",
    utc: "-06:00"
  },
  {
    label: "MST7MDT (GMT-06:00)",
    tzCode: "MST7MDT",
    name: "(GMT-06:00) MST7MDT",
    utc: "-06:00"
  },
  {
    label: "Pacific/Galapagos (GMT-06:00)",
    tzCode: "Pacific/Galapagos",
    name: "(GMT-06:00) Pacific Galapagos",
    utc: "-06:00"
  },
  {
    label: "America/Atikokan (GMT-05:00)",
    tzCode: "America/Atikokan",
    name: "(GMT-05:00) America Atikokan",
    utc: "-05:00"
  },
  {
    label: "America/Bahia Banderas (GMT-05:00)",
    tzCode: "America/Bahia_Banderas",
    name: "(GMT-05:00) America Bahia Banderas",
    utc: "-05:00"
  },
  {
    label: "America/Bogota (GMT-05:00)",
    tzCode: "America/Bogota",
    name: "(GMT-05:00) America Bogota",
    utc: "-05:00"
  },
  {
    label: "America/Cancun (GMT-05:00)",
    tzCode: "America/Cancun",
    name: "(GMT-05:00) America Cancun",
    utc: "-05:00"
  },
  {
    label: "America/Cayman (GMT-05:00)",
    tzCode: "America/Cayman",
    name: "(GMT-05:00) America Cayman",
    utc: "-05:00"
  },
  {
    label: "America/Chicago (GMT-05:00)",
    tzCode: "America/Chicago",
    name: "(GMT-05:00) America Chicago",
    utc: "-05:00"
  },
  {
    label: "America/Eirunepe (GMT-05:00)",
    tzCode: "America/Eirunepe",
    name: "(GMT-05:00) America Eirunepe",
    utc: "-05:00"
  },
  {
    label: "America/Guayaquil (GMT-05:00)",
    tzCode: "America/Guayaquil",
    name: "(GMT-05:00) America Guayaquil",
    utc: "-05:00"
  },
  {
    label: "America/Indiana/Knox (GMT-05:00)",
    tzCode: "America/Indiana_Knox",
    name: "(GMT-05:00) America Indiana Knox",
    utc: "-05:00"
  },
  {
    label: "America/Indiana/Tell City (GMT-05:00)",
    tzCode: "America/Indiana_Tell_City",
    name: "(GMT-05:00) America Indiana Tell City",
    utc: "-05:00"
  },
  {
    label: "America/Jamaica (GMT-05:00)",
    tzCode: "America/Jamaica",
    name: "(GMT-05:00) America Jamaica",
    utc: "-05:00"
  },
  {
    label: "America/Lima (GMT-05:00)",
    tzCode: "America/Lima",
    name: "(GMT-05:00) America Lima",
    utc: "-05:00"
  },
  {
    label: "America/Matamoros (GMT-05:00)",
    tzCode: "America/Matamoros",
    name: "(GMT-05:00) America Matamoros",
    utc: "-05:00"
  },
  {
    label: "America/Menominee (GMT-05:00)",
    tzCode: "America/Menominee",
    name: "(GMT-05:00) America Menominee",
    utc: "-05:00"
  },
  {
    label: "America/Merida (GMT-05:00)",
    tzCode: "America/Merida",
    name: "(GMT-05:00) America Merida",
    utc: "-05:00"
  },
  {
    label: "America/Mexico City (GMT-05:00)",
    tzCode: "America/Mexico_City",
    name: "(GMT-05:00) America Mexico City",
    utc: "-05:00"
  },
  {
    label: "America/Monterrey (GMT-05:00)",
    tzCode: "America/Monterrey",
    name: "(GMT-05:00) America Monterrey",
    utc: "-05:00"
  },
  {
    label: "America/North Dakota/Beulah (GMT-05:00)",
    tzCode: "America/North_Dakota/Beulah",
    name: "(GMT-05:00) America North Dakota Beulah",
    utc: "-05:00"
  },
  {
    label: "America/North Dakota/Center (GMT-05:00)",
    tzCode: "America/North_Dakota/Center",
    name: "(GMT-05:00) America North Dakota Center",
    utc: "-05:00"
  },
  {
    label: "America/North Dakota/New_Salem (GMT-05:00)",
    tzCode: "America/North_Dakota/New_Salem",
    name: "(GMT-05:00) America North Dakota New Salem",
    utc: "-05:00"
  },
  {
    label: "America/Panama (GMT-05:00)",
    tzCode: "America/Panama",
    name: "(GMT-05:00) America Panama",
    utc: "-05:00"
  },
  {
    label: "America/Rainy River (GMT-05:00)",
    tzCode: "America/Rainy_River",
    name: "(GMT-05:00) America Rainy River",
    utc: "-05:00"
  },
  {
    label: "America/Rankin Inlet (GMT-05:00)",
    tzCode: "America/Rankin_Inlet",
    name: "(GMT-05:00) America Rankin Inlet",
    utc: "-05:00"
  },
  {
    label: "America/Resolute (GMT-05:00)",
    tzCode: "America/Resolute",
    name: "(GMT-05:00) America Resolute",
    utc: "-05:00"
  },
  {
    label: "America/Rio Branco (GMT-05:00)",
    tzCode: "America/Rio_Branco",
    name: "(GMT-05:00) America Rio Branco",
    utc: "-05:00"
  },
  {
    label: "America/Winnipeg (GMT-05:00)",
    tzCode: "America/Winnipeg",
    name: "(GMT-05:00) America Winnipeg",
    utc: "-05:00"
  },
  {
    label: "CST6CDT (GMT-05:00)",
    tzCode: "CST6CDT",
    name: "(GMT-05:00) CST6CDT",
    utc: "-05:00"
  },
  {
    label: "EST (GMT-05:00)",
    tzCode: "EST",
    name: "(GMT-05:00) EST",
    utc: "-05:00"
  },
  {
    label: "Etc/GMT+5 (GMT-05:00)",
    tzCode: "Etc/GMT+5",
    name: "(GMT-05:00) Etc GMT+5",
    utc: "-05:00"
  },
  {
    label: "Pacific/Easter (GMT-05:00)",
    tzCode: "Pacific/Easter",
    name: "(GMT-05:00) Pacific Easter",
    utc: "-05:00"
  },
  {
    label: "America/Anguilla (GMT-04:00)",
    tzCode: "America/Anguilla",
    name: "(GMT-04:00) America Anguilla",
    utc: "-04:00"
  },
  {
    label: "America/Antigua (GMT-04:00)",
    tzCode: "America/Antigua",
    name: "(GMT-04:00) America Antigua",
    utc: "-04:00"
  },
  {
    label: "America/Aruba (GMT-04:00)",
    tzCode: "America/Aruba",
    name: "(GMT-04:00) America Aruba",
    utc: "-04:00"
  },
  {
    label: "America/Asuncion (GMT-04:00)",
    tzCode: "America/Asuncion",
    name: "(GMT-04:00) America Asuncion",
    utc: "-04:00"
  },
  {
    label: "America/Barbados (GMT-04:00)",
    tzCode: "America/Barbados",
    name: "(GMT-04:00) America Barbados",
    utc: "-04:00"
  },
  {
    label: "America/Blanc-Sablon (GMT-04:00)",
    tzCode: "America/Blanc_Sablon",
    name: "(GMT-04:00) America Blanc-Sablon",
    utc: "-04:00"
  },
  {
    label: "America/Boa Vista (GMT-04:00)",
    tzCode: "America/Boa_Vista",
    name: "(GMT-04:00) America Boa Vista",
    utc: "-04:00"
  },
  {
    label: "America/Campo Grande (GMT-04:00)",
    tzCode: "America/Campo_Grande",
    name: "(GMT-04:00) America Campo Grande",
    utc: "-04:00"
  },
  {
    label: "America/Caracas (GMT-04:00)",
    tzCode: "America/Caracas",
    name: "(GMT-04:00) America Caracas",
    utc: "-04:00"
  },
  {
    label: "America/Cuiaba (GMT-04:00)",
    tzCode: "America/Cuiaba",
    name: "(GMT-04:00) America Cuiaba",
    utc: "-04:00"
  },
  {
    label: "America/Curacao (GMT-04:00)",
    tzCode: "America/Curacao",
    name: "(GMT-04:00) America Curacao",
    utc: "-04:00"
  },
  {
    label: "America/Detroit (GMT-04:00)",
    tzCode: "America/Detroit",
    name: "(GMT-04:00) America Detroit",
    utc: "-04:00"
  },
  {
    label: "America/Dominica (GMT-04:00)",
    tzCode: "America/Dominica",
    name: "(GMT-04:00) America Dominica",
    utc: "-04:00"
  },
  {
    label: "America/Grand Turk (GMT-04:00)",
    tzCode: "America/Grand_Turk",
    name: "(GMT-04:00) America Grand Turk",
    utc: "-04:00"
  },
  {
    label: "America/Grenada (GMT-04:00)",
    tzCode: "America/Grenada",
    name: "(GMT-04:00) America Grenada",
    utc: "-04:00"
  },
  {
    label: "America/Guadeloupe (GMT-04:00)",
    tzCode: "America/Guadeloupe",
    name: "(GMT-04:00) America Guadeloupe",
    utc: "-04:00"
  },
  {
    label: "America/Guyana (GMT-04:00)",
    tzCode: "America/Guyana",
    name: "(GMT-04:00) America Guyana",
    utc: "-04:00"
  },
  {
    label: "America/Havana (GMT-04:00)",
    tzCode: "America/Havana",
    name: "(GMT-04:00) America Havana",
    utc: "-04:00"
  },
  {
    label: "America/Indiana/Indianapolis (GMT-04:00)",
    tzCode: "America/Indiana_Indianapolis",
    name: "(GMT-04:00) America Indiana Indianapolis",
    utc: "-04:00"
  },
  {
    label: "America/Indiana/Marengo (GMT-04:00)",
    tzCode: "America/Indiana_Marengo",
    name: "(GMT-04:00) America Indiana Marengo",
    utc: "-04:00"
  },
  {
    label: "America/Indiana/Petersburg (GMT-04:00)",
    tzCode: "America/Indiana_Petersburg",
    name: "(GMT-04:00) America Indiana Petersburg",
    utc: "-04:00"
  },
  {
    label: "America/Indiana/Vevay (GMT-04:00)",
    tzCode: "America/Indiana_Vevay",
    name: "(GMT-04:00) America Indiana Vevay",
    utc: "-04:00"
  },
  {
    label: "America/Indiana/Vincennes (GMT-04:00)",
    tzCode: "America/Indiana_Vincennes",
    name: "(GMT-04:00) America Indiana Vincennes",
    utc: "-04:00"
  },
  {
    label: "America/Indiana/Winamac (GMT-04:00)",
    tzCode: "America/Indiana_Winamac",
    name: "(GMT-04:00) America Indiana Winamac",
    utc: "-04:00"
  },
  {
    label: "America/Indianapolis (GMT-04:00)",
    tzCode: "America/Indianapolis",
    name: "(GMT-04:00) America Indianapolis",
    utc: "-04:00"
  },
  {
    label: "America/Iqaluit (GMT-04:00)",
    tzCode: "America/Iqaluit",
    name: "(GMT-04:00) America Iqaluit",
    utc: "-04:00"
  },
  {
    label: "America/Kentucky/Louisville (GMT-04:00)",
    tzCode: "America/Kentucky_Louisville",
    name: "(GMT-04:00) America Kentucky Louisville",
    utc: "-04:00"
  },
  {
    label: "America/Kentucky/Monticello (GMT-04:00)",
    tzCode: "America/Kentucky_Monticello",
    name: "(GMT-04:00) America Kentucky Monticello",
    utc: "-04:00"
  },
  {
    label: "America/Kralendijk (GMT-04:00)",
    tzCode: "America/Kralendijk",
    name: "(GMT-04:00) America Kralendijk",
    utc: "-04:00"
  },
  {
    label: "America/La Paz (GMT-04:00)",
    tzCode: "America/La_Paz",
    name: "(GMT-04:00) America La Paz",
    utc: "-04:00"
  },
  {
    label: "America/Lower Princes (GMT-04:00)",
    tzCode: "America/Lower_Princes",
    name: "(GMT-04:00) America Lower Princes",
    utc: "-04:00"
  },
  {
    label: "America/Manaus (GMT-04:00)",
    tzCode: "America/Manaus",
    name: "(GMT-04:00) America Manaus",
    utc: "-04:00"
  },
  {
    label: "America/Marigot (GMT-04:00)",
    tzCode: "America/Marigot",
    name: "(GMT-04:00) America Marigot",
    utc: "-04:00"
  },
  {
    label: "America/Martinique (GMT-04:00)",
    tzCode: "America/Martinique",
    name: "(GMT-04:00) America Martinique",
    utc: "-04:00"
  },
  {
    label: "America/Montreal (GMT-04:00)",
    tzCode: "America/Montreal",
    name: "(GMT-04:00) America Montreal",
    utc: "-04:00"
  },
  {
    label: "America/Montserrat (GMT-04:00)",
    tzCode: "America/Montserrat",
    name: "(GMT-04:00) America Montserrat",
    utc: "-04:00"
  },
  {
    label: "America/Nassau (GMT-04:00)",
    tzCode: "America/Nassau",
    name: "(GMT-04:00) America Nassau",
    utc: "-04:00"
  },
  {
    label: "America/New York (GMT-04:00)",
    tzCode: "America/New_York",
    name: "(GMT-04:00) America New York",
    utc: "-04:00"
  },
  {
    label: "America/Nipigon (GMT-04:00)",
    tzCode: "America/Nipigon",
    name: "(GMT-04:00) America Nipigon",
    utc: "-04:00"
  },
  {
    label: "America/Pangnirtung (GMT-04:00)",
    tzCode: "America/Pangnirtung",
    name: "(GMT-04:00) America Pangnirtung",
    utc: "-04:00"
  },
  {
    label: "America/Port-au-Prince (GMT-04:00)",
    tzCode: "America/Port_au-Prince",
    name: "(GMT-04:00) America Port-au-Prince",
    utc: "-04:00"
  },
  {
    label: "America/Port of_Spain (GMT-04:00)",
    tzCode: "America/Port_of_Spain",
    name: "(GMT-04:00) America Port of Spain",
    utc: "-04:00"
  },
  {
    label: "America/Porto Velho (GMT-04:00)",
    tzCode: "America/Porto_Velho",
    name: "(GMT-04:00) America Porto Velho",
    utc: "-04:00"
  },
  {
    label: "America/Puerto Rico (GMT-04:00)",
    tzCode: "America/Puerto_Rico",
    name: "(GMT-04:00) America Puerto Rico",
    utc: "-04:00"
  },
  {
    label: "America/Santo Domingo (GMT-04:00)",
    tzCode: "America/Santo_Domingo",
    name: "(GMT-04:00) America Santo Domingo",
    utc: "-04:00"
  },
  {
    label: "America/St Barthelemy (GMT-04:00)",
    tzCode: "America/St_Barthelemy",
    name: "(GMT-04:00) America St Barthelemy",
    utc: "-04:00"
  },
  {
    label: "America/St Kitts (GMT-04:00)",
    tzCode: "America/St_Kitts",
    name: "(GMT-04:00) America St Kitts",
    utc: "-04:00"
  },
  {
    label: "America/St Lucia (GMT-04:00)",
    tzCode: "America/St_Lucia",
    name: "(GMT-04:00) America St Lucia",
    utc: "-04:00"
  },
  {
    label: "America/St Thomas (GMT-04:00)",
    tzCode: "America/St_Thomas",
    name: "(GMT-04:00) America St Thomas",
    utc: "-04:00"
  },
  {
    label: "America/St Vincent (GMT-04:00)",
    tzCode: "America/St_Vincent",
    name: "(GMT-04:00) America St Vincent",
    utc: "-04:00"
  },
  {
    label: "America/Thunder Bay (GMT-04:00)",
    tzCode: "America/Thunder_Bay",
    name: "(GMT-04:00) America Thunder Bay",
    utc: "-04:00"
  },
  {
    label: "America/Toronto (GMT-04:00)",
    tzCode: "America/Toronto",
    name: "(GMT-04:00) America Toronto",
    utc: "-04:00"
  },
  {
    label: "America/Tortola (GMT-04:00)",
    tzCode: "America/Tortola",
    name: "(GMT-04:00) America Tortola",
    utc: "-04:00"
  },
  {
    label: "EST5EDT (GMT-04:00)",
    tzCode: "EST5EDT",
    name: "(GMT-04:00) EST5EDT",
    utc: "-04:00"
  },
  {
    label: "Etc/GMT+4 (GMT-04:00)",
    tzCode: "Etc/GMT+4",
    name: "(GMT-04:00) Etc GMT+4",
    utc: "-04:00"
  },
  {
    label: "America/Araguaina (GMT-03:00)",
    tzCode: "America/Araguaina",
    name: "(GMT-03:00) America Araguaina",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/Buenos Aires (GMT-03:00)",
    tzCode: "America/Argentina_Buenos_Aires",
    name: "(GMT-03:00) America Argentina Buenos Aires",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/Catamarca (GMT-03:00)",
    tzCode: "America/Argentina_Catamarca",
    name: "(GMT-03:00) America Argentina Catamarca",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/Cordoba (GMT-03:00)",
    tzCode: "America/Argentina_Cordoba",
    name: "(GMT-03:00) America Argentina Cordoba",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/Jujuy (GMT-03:00)",
    tzCode: "America/Argentina_Jujuy",
    name: "(GMT-03:00) America Argentina Jujuy",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/La Rioja (GMT-03:00)",
    tzCode: "America/Argentina_La_Rioja",
    name: "(GMT-03:00) America Argentina La Rioja",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/Mendoza (GMT-03:00)",
    tzCode: "America/Argentina_Mendoza",
    name: "(GMT-03:00) America Argentina Mendoza",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/Rio Gallegos (GMT-03:00)",
    tzCode: "America/Argentina_Rio_Gallegos",
    name: "(GMT-03:00) America Argentina Rio Gallegos",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/Salta (GMT-03:00)",
    tzCode: "America/Argentina_Salta",
    name: "(GMT-03:00) America Argentina Salta",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/San Juan (GMT-03:00)",
    tzCode: "America/Argentina_San_Juan",
    name: "(GMT-03:00) America Argentina San Juan",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/San Luis (GMT-03:00)",
    tzCode: "America/Argentina_San_Luis",
    name: "(GMT-03:00) America Argentina San Luis",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/Tucuman (GMT-03:00)",
    tzCode: "America/Argentina_Tucuman",
    name: "(GMT-03:00) America Argentina Tucuman",
    utc: "-03:00"
  },
  {
    label: "America/Argentina/Ushuaia (GMT-03:00)",
    tzCode: "America/Argentina_Ushuaia",
    name: "(GMT-03:00) America Argentina Ushuaia",
    utc: "-03:00"
  },
  {
    label: "America/Bahia (GMT-03:00)",
    tzCode: "America/Bahia",
    name: "(GMT-03:00) America Bahia",
    utc: "-03:00"
  },
  {
    label: "America/Belem (GMT-03:00)",
    tzCode: "America/Belem",
    name: "(GMT-03:00) America Belem",
    utc: "-03:00"
  },
  {
    label: "America/Cayenne (GMT-03:00)",
    tzCode: "America/Cayenne",
    name: "(GMT-03:00) America Cayenne",
    utc: "-03:00"
  },
  {
    label: "America/Fortaleza (GMT-03:00)",
    tzCode: "America/Fortaleza",
    name: "(GMT-03:00) America Fortaleza",
    utc: "-03:00"
  },
  {
    label: "America/Glace Bay (GMT-03:00)",
    tzCode: "America/Glace_Bay",
    name: "(GMT-03:00) America Glace Bay",
    utc: "-03:00"
  },
  {
    label: "America/Goose Bay (GMT-03:00)",
    tzCode: "America/Goose_Bay",
    name: "(GMT-03:00) America Goose Bay",
    utc: "-03:00"
  },
  {
    label: "America/Halifax (GMT-03:00)",
    tzCode: "America/Halifax",
    name: "(GMT-03:00) America Halifax",
    utc: "-03:00"
  },
  {
    label: "America/Maceio (GMT-03:00)",
    tzCode: "America/Maceio",
    name: "(GMT-03:00) America Maceio",
    utc: "-03:00"
  },
  {
    label: "America/Moncton (GMT-03:00)",
    tzCode: "America/Moncton",
    name: "(GMT-03:00) America Moncton",
    utc: "-03:00"
  },
  {
    label: "America/Montevideo (GMT-03:00)",
    tzCode: "America/Montevideo",
    name: "(GMT-03:00) America Montevideo",
    utc: "-03:00"
  },
  {
    label: "America/Paramaribo (GMT-03:00)",
    tzCode: "America/Paramaribo",
    name: "(GMT-03:00) America Paramaribo",
    utc: "-03:00"
  },
  {
    label: "America/Punta Arenas (GMT-03:00)",
    tzCode: "America/Punta_Arenas",
    name: "(GMT-03:00) America Punta Arenas",
    utc: "-03:00"
  },
  {
    label: "America/Recife (GMT-03:00)",
    tzCode: "America/Recife",
    name: "(GMT-03:00) America Recife",
    utc: "-03:00"
  },
  {
    label: "America/Santarem (GMT-03:00)",
    tzCode: "America/Santarem",
    name: "(GMT-03:00) America Santarem",
    utc: "-03:00"
  },
  {
    label: "America/Santiago (GMT-03:00)",
    tzCode: "America/Santiago",
    name: "(GMT-03:00) America Santiago",
    utc: "-03:00"
  },
  {
    label: "America/Sao Paulo (GMT-03:00)",
    tzCode: "America/Sao_Paulo",
    name: "(GMT-03:00) America Sao Paulo",
    utc: "-03:00"
  },
  {
    label: "America/Thule (GMT-03:00)",
    tzCode: "America/Thule",
    name: "(GMT-03:00) America Thule",
    utc: "-03:00"
  },
  {
    label: "Antarctica/Palmer (GMT-03:00)",
    tzCode: "Antarctica/Palmer",
    name: "(GMT-03:00) Antarctica Palmer",
    utc: "-03:00"
  },
  {
    label: "Antarctica/Rothera (GMT-03:00)",
    tzCode: "Antarctica/Rothera",
    name: "(GMT-03:00) Antarctica Rothera",
    utc: "-03:00"
  },
  {
    label: "Atlantic/Bermuda (GMT-03:00)",
    tzCode: "Atlantic/Bermuda",
    name: "(GMT-03:00) Atlantic Bermuda",
    utc: "-03:00"
  },
  {
    label: "Atlantic/Stanley (GMT-03:00)",
    tzCode: "Atlantic/Stanley",
    name: "(GMT-03:00) Atlantic Stanley",
    utc: "-03:00"
  },
  {
    label: "Etc/GMT+3 (GMT-03:00)",
    tzCode: "Etc/GMT+3",
    name: "(GMT-03:00) Etc GMT+3",
    utc: "-03:00"
  },
  {
    label: "America/St Johns (GMT-02:30)",
    tzCode: "America/St_Johns",
    name: "(GMT-02:30) America St Johns",
    utc: "-02:30"
  },
  {
    label: "America/Godthab (GMT-02:00)",
    tzCode: "America/Godthab",
    name: "(GMT-02:00) America Godthab",
    utc: "-02:00"
  },
  {
    label: "America/Miquelon (GMT-02:00)",
    tzCode: "America/Miquelon",
    name: "(GMT-02:00) America Miquelon",
    utc: "-02:00"
  },
  {
    label: "America/Noronha (GMT-02:00)",
    tzCode: "America/Noronha",
    name: "(GMT-02:00) America Noronha",
    utc: "-02:00"
  },
  {
    label: "America/Nuuk (GMT-02:00)",
    tzCode: "America/Nuuk",
    name: "(GMT-02:00) America Nuuk",
    utc: "-02:00"
  },
  {
    label: "Atlantic/South Georgia (GMT-02:00)",
    tzCode: "Atlantic/South_Georgia",
    name: "(GMT-02:00) Atlantic South Georgia",
    utc: "-02:00"
  },
  {
    label: "Etc/GMT+2 (GMT-02:00)",
    tzCode: "Etc/GMT+2",
    name: "(GMT-02:00) Etc GMT+2",
    utc: "-02:00"
  },
  {
    label: "Atlantic/Cape Verde (GMT-01:00)",
    tzCode: "Atlantic/Cape_Verde",
    name: "(GMT-01:00) Atlantic Cape Verde",
    utc: "-01:00"
  },
  {
    label: "Etc/GMT+1 (GMT-01:00)",
    tzCode: "Etc/GMT+1",
    name: "(GMT-01:00) Etc GMT+1",
    utc: "-01:00"
  },
  {
    label: "Africa/Abidjan (GMT+00:00)",
    tzCode: "Africa/Abidjan",
    name: "(GMT+00:00) Africa Abidjan",
    utc: "+00:00"
  },
  {
    label: "Africa/Accra (GMT+00:00)",
    tzCode: "Africa/Accra",
    name: "(GMT+00:00) Africa Accra",
    utc: "+00:00"
  },
  {
    label: "Africa/Bamako (GMT+00:00)",
    tzCode: "Africa/Bamako",
    name: "(GMT+00:00) Africa Bamako",
    utc: "+00:00"
  },
  {
    label: "Africa/Banjul (GMT+00:00)",
    tzCode: "Africa/Banjul",
    name: "(GMT+00:00) Africa Banjul",
    utc: "+00:00"
  },
  {
    label: "Africa/Bissau (GMT+00:00)",
    tzCode: "Africa/Bissau",
    name: "(GMT+00:00) Africa Bissau",
    utc: "+00:00"
  },
  {
    label: "Africa/Conakry (GMT+00:00)",
    tzCode: "Africa/Conakry",
    name: "(GMT+00:00) Africa Conakry",
    utc: "+00:00"
  },
  {
    label: "Africa/Dakar (GMT+00:00)",
    tzCode: "Africa/Dakar",
    name: "(GMT+00:00) Africa Dakar",
    utc: "+00:00"
  },
  {
    label: "Africa/Freetown (GMT+00:00)",
    tzCode: "Africa/Freetown",
    name: "(GMT+00:00) Africa Freetown",
    utc: "+00:00"
  },
  {
    label: "Africa/Lome (GMT+00:00)",
    tzCode: "Africa/Lome",
    name: "(GMT+00:00) Africa Lome",
    utc: "+00:00"
  },
  {
    label: "Africa/Monrovia (GMT+00:00)",
    tzCode: "Africa/Monrovia",
    name: "(GMT+00:00) Africa Monrovia",
    utc: "+00:00"
  },
  {
    label: "Africa/Nouakchott (GMT+00:00)",
    tzCode: "Africa/Nouakchott",
    name: "(GMT+00:00) Africa Nouakchott",
    utc: "+00:00"
  },
  {
    label: "Africa/Ouagadougou (GMT+00:00)",
    tzCode: "Africa/Ouagadougou",
    name: "(GMT+00:00) Africa Ouagadougou",
    utc: "+00:00"
  },
  {
    label: "Africa/Sao Tome (GMT+00:00)",
    tzCode: "Africa/Sao_Tome",
    name: "(GMT+00:00) Africa Sao Tome",
    utc: "+00:00"
  },
  {
    label: "America/Danmarkshavn (GMT+00:00)",
    tzCode: "America/Danmarkshavn",
    name: "(GMT+00:00) America Danmarkshavn",
    utc: "+00:00"
  },
  {
    label: "America/Scoresbysund (GMT+00:00)",
    tzCode: "America/Scoresbysund",
    name: "(GMT+00:00) America Scoresbysund",
    utc: "+00:00"
  },
  {
    label: "Atlantic/Azores (GMT+00:00)",
    tzCode: "Atlantic/Azores",
    name: "(GMT+00:00) Atlantic Azores",
    utc: "+00:00"
  },
  {
    label: "Atlantic/Reykjavik (GMT+00:00)",
    tzCode: "Atlantic/Reykjavik",
    name: "(GMT+00:00) Atlantic Reykjavik",
    utc: "+00:00"
  },
  {
    label: "Atlantic/St Helena (GMT+00:00)",
    tzCode: "Atlantic/St_Helena",
    name: "(GMT+00:00) Atlantic St Helena",
    utc: "+00:00"
  },
  {
    label: "Etc/GMT (GMT+00:00)",
    tzCode: "Etc/GMT",
    name: "(GMT+00:00) Etc GMT",
    utc: "+00:00"
  },
  {
    label: "Etc/GMT+0 (GMT+00:00)",
    tzCode: "Etc/GMT+0",
    name: "(GMT+00:00) Etc GMT+0",
    utc: "+00:00"
  },
  {
    label: "Etc/GMT-0 (GMT+00:00)",
    tzCode: "Etc/GMT_0",
    name: "(GMT+00:00) Etc GMT-0",
    utc: "+00:00"
  },
  {
    label: "Etc/GMT0 (GMT+00:00)",
    tzCode: "Etc/GMT0",
    name: "(GMT+00:00) Etc GMT0",
    utc: "+00:00"
  },
  {
    label: "Etc/Greenwich (GMT+00:00)",
    tzCode: "Etc/Greenwich",
    name: "(GMT+00:00) Etc Greenwich",
    utc: "+00:00"
  },
  {
    label: "Etc/Universal (GMT+00:00)",
    tzCode: "Etc/Universal",
    name: "(GMT+00:00) Etc Universal",
    utc: "+00:00"
  },
  {
    label: "Etc/Zulu (GMT+00:00)",
    tzCode: "Etc/Zulu",
    name: "(GMT+00:00) Etc Zulu",
    utc: "+00:00"
  },
  {
    label: "GMT (GMT+00:00)",
    tzCode: "GMT",
    name: "(GMT+00:00) GMT",
    utc: "+00:00"
  },
  {
    label: "UTC (GMT+00:00)",
    tzCode: "UTC",
    name: "(GMT+00:00) UTC",
    utc: "+00:00"
  },
  {
    label: "Africa/Algiers (GMT+01:00)",
    tzCode: "Africa/Algiers",
    name: "(GMT+01:00) Africa Algiers",
    utc: "+01:00"
  },
  {
    label: "Africa/Bangui (GMT+01:00)",
    tzCode: "Africa/Bangui",
    name: "(GMT+01:00) Africa Bangui",
    utc: "+01:00"
  },
  {
    label: "Africa/Brazzaville (GMT+01:00)",
    tzCode: "Africa/Brazzaville",
    name: "(GMT+01:00) Africa Brazzaville",
    utc: "+01:00"
  },
  {
    label: "Africa/Casablanca (GMT+01:00)",
    tzCode: "Africa/Casablanca",
    name: "(GMT+01:00) Africa Casablanca",
    utc: "+01:00"
  },
  {
    label: "Africa/Douala (GMT+01:00)",
    tzCode: "Africa/Douala",
    name: "(GMT+01:00) Africa Douala",
    utc: "+01:00"
  },
  {
    label: "Africa/El Aaiun (GMT+01:00)",
    tzCode: "Africa/El_Aaiun",
    name: "(GMT+01:00) Africa El Aaiun",
    utc: "+01:00"
  },
  {
    label: "Africa/Kinshasa (GMT+01:00)",
    tzCode: "Africa/Kinshasa",
    name: "(GMT+01:00) Africa Kinshasa",
    utc: "+01:00"
  },
  {
    label: "Africa/Lagos (GMT+01:00)",
    tzCode: "Africa/Lagos",
    name: "(GMT+01:00) Africa Lagos",
    utc: "+01:00"
  },
  {
    label: "Africa/Libreville (GMT+01:00)",
    tzCode: "Africa/Libreville",
    name: "(GMT+01:00) Africa Libreville",
    utc: "+01:00"
  },
  {
    label: "Africa/Luanda (GMT+01:00)",
    tzCode: "Africa/Luanda",
    name: "(GMT+01:00) Africa Luanda",
    utc: "+01:00"
  },
  {
    label: "Africa/Malabo (GMT+01:00)",
    tzCode: "Africa/Malabo",
    name: "(GMT+01:00) Africa Malabo",
    utc: "+01:00"
  },
  {
    label: "Africa/Ndjamena (GMT+01:00)",
    tzCode: "Africa/Ndjamena",
    name: "(GMT+01:00) Africa Ndjamena",
    utc: "+01:00"
  },
  {
    label: "Africa/Niamey (GMT+01:00)",
    tzCode: "Africa/Niamey",
    name: "(GMT+01:00) Africa Niamey",
    utc: "+01:00"
  },
  {
    label: "Africa/Porto-Novo (GMT+01:00)",
    tzCode: "Africa/Porto_Novo",
    name: "(GMT+01:00) Africa Porto-Novo",
    utc: "+01:00"
  },
  {
    label: "Africa/Tunis (GMT+01:00)",
    tzCode: "Africa/Tunis",
    name: "(GMT+01:00) Africa Tunis",
    utc: "+01:00"
  },
  {
    label: "Atlantic/Canary (GMT+01:00)",
    tzCode: "Atlantic/Canary",
    name: "(GMT+01:00) Atlantic Canary",
    utc: "+01:00"
  },
  {
    label: "Atlantic/Faroe (GMT+01:00)",
    tzCode: "Atlantic/Faroe",
    name: "(GMT+01:00) Atlantic Faroe",
    utc: "+01:00"
  },
  {
    label: "Atlantic/Madeira (GMT+01:00)",
    tzCode: "Atlantic/Madeira",
    name: "(GMT+01:00) Atlantic Madeira",
    utc: "+01:00"
  },
  {
    label: "Etc/GMT-1 (GMT+01:00)",
    tzCode: "Etc/GMT_1",
    name: "(GMT+01:00) Etc GMT-1",
    utc: "+01:00"
  },
  {
    label: "Europe/Dublin (GMT+01:00)",
    tzCode: "Europe/Dublin",
    name: "(GMT+01:00) Europe Dublin",
    utc: "+01:00"
  },
  {
    label: "Europe/Guernsey (GMT+01:00)",
    tzCode: "Europe/Guernsey",
    name: "(GMT+01:00) Europe Guernsey",
    utc: "+01:00"
  },
  {
    label: "Europe/Isle of_Man (GMT+01:00)",
    tzCode: "Europe/Isle_of_Man",
    name: "(GMT+01:00) Europe Isle of Man",
    utc: "+01:00"
  },
  {
    label: "Europe/Jersey (GMT+01:00)",
    tzCode: "Europe/Jersey",
    name: "(GMT+01:00) Europe Jersey",
    utc: "+01:00"
  },
  {
    label: "Europe/Lisbon (GMT+01:00)",
    tzCode: "Europe/Lisbon",
    name: "(GMT+01:00) Europe Lisbon",
    utc: "+01:00"
  },
  {
    label: "Europe/London (GMT+01:00)",
    tzCode: "Europe/London",
    name: "(GMT+01:00) Europe London",
    utc: "+01:00"
  },
  {
    label: "WET (GMT+01:00)",
    tzCode: "WET",
    name: "(GMT+01:00) WET",
    utc: "+01:00"
  },
  {
    label: "Africa/Blantyre (GMT+02:00)",
    tzCode: "Africa/Blantyre",
    name: "(GMT+02:00) Africa Blantyre",
    utc: "+02:00"
  },
  {
    label: "Africa/Bujumbura (GMT+02:00)",
    tzCode: "Africa/Bujumbura",
    name: "(GMT+02:00) Africa Bujumbura",
    utc: "+02:00"
  },
  {
    label: "Africa/Cairo (GMT+02:00)",
    tzCode: "Africa/Cairo",
    name: "(GMT+02:00) Africa Cairo",
    utc: "+02:00"
  },
  {
    label: "Africa/Ceuta (GMT+02:00)",
    tzCode: "Africa/Ceuta",
    name: "(GMT+02:00) Africa Ceuta",
    utc: "+02:00"
  },
  {
    label: "Africa/Gaborone (GMT+02:00)",
    tzCode: "Africa/Gaborone",
    name: "(GMT+02:00) Africa Gaborone",
    utc: "+02:00"
  },
  {
    label: "Africa/Harare (GMT+02:00)",
    tzCode: "Africa/Harare",
    name: "(GMT+02:00) Africa Harare",
    utc: "+02:00"
  },
  {
    label: "Africa/Johannesburg (GMT+02:00)",
    tzCode: "Africa/Johannesburg",
    name: "(GMT+02:00) Africa Johannesburg",
    utc: "+02:00"
  },
  {
    label: "Africa/Juba (GMT+02:00)",
    tzCode: "Africa/Juba",
    name: "(GMT+02:00) Africa Juba",
    utc: "+02:00"
  },
  {
    label: "Africa/Khartoum (GMT+02:00)",
    tzCode: "Africa/Khartoum",
    name: "(GMT+02:00) Africa Khartoum",
    utc: "+02:00"
  },
  {
    label: "Africa/Kigali (GMT+02:00)",
    tzCode: "Africa/Kigali",
    name: "(GMT+02:00) Africa Kigali",
    utc: "+02:00"
  },
  {
    label: "Africa/Lubumbashi (GMT+02:00)",
    tzCode: "Africa/Lubumbashi",
    name: "(GMT+02:00) Africa Lubumbashi",
    utc: "+02:00"
  },
  {
    label: "Africa/Lusaka (GMT+02:00)",
    tzCode: "Africa/Lusaka",
    name: "(GMT+02:00) Africa Lusaka",
    utc: "+02:00"
  },
  {
    label: "Africa/Maputo (GMT+02:00)",
    tzCode: "Africa/Maputo",
    name: "(GMT+02:00) Africa Maputo",
    utc: "+02:00"
  },
  {
    label: "Africa/Maseru (GMT+02:00)",
    tzCode: "Africa/Maseru",
    name: "(GMT+02:00) Africa Maseru",
    utc: "+02:00"
  },
  {
    label: "Africa/Mbabane (GMT+02:00)",
    tzCode: "Africa/Mbabane",
    name: "(GMT+02:00) Africa Mbabane",
    utc: "+02:00"
  },
  {
    label: "Africa/Tripoli (GMT+02:00)",
    tzCode: "Africa/Tripoli",
    name: "(GMT+02:00) Africa Tripoli",
    utc: "+02:00"
  },
  {
    label: "Africa/Windhoek (GMT+02:00)",
    tzCode: "Africa/Windhoek",
    name: "(GMT+02:00) Africa Windhoek",
    utc: "+02:00"
  },
  {
    label: "Antarctica/Troll (GMT+02:00)",
    tzCode: "Antarctica/Troll",
    name: "(GMT+02:00) Antarctica Troll",
    utc: "+02:00"
  },
  {
    label: "Arctic/Longyearbyen (GMT+02:00)",
    tzCode: "Arctic/Longyearbyen",
    name: "(GMT+02:00) Arctic Longyearbyen",
    utc: "+02:00"
  },
  {
    label: "CET (GMT+02:00)",
    tzCode: "CET",
    name: "(GMT+02:00) CET",
    utc: "+02:00"
  },
  {
    label: "Etc/GMT-2 (GMT+02:00)",
    tzCode: "Etc/GMT_2",
    name: "(GMT+02:00) Etc GMT-2",
    utc: "+02:00"
  },
  {
    label: "Europe/Amsterdam (GMT+02:00)",
    tzCode: "Europe/Amsterdam",
    name: "(GMT+02:00) Europe Amsterdam",
    utc: "+02:00"
  },
  {
    label: "Europe/Andorra (GMT+02:00)",
    tzCode: "Europe/Andorra",
    name: "(GMT+02:00) Europe Andorra",
    utc: "+02:00"
  },
  {
    label: "Europe/Belgrade (GMT+02:00)",
    tzCode: "Europe/Belgrade",
    name: "(GMT+02:00) Europe Belgrade",
    utc: "+02:00"
  },
  {
    label: "Europe/Berlin (GMT+02:00)",
    tzCode: "Europe/Berlin",
    name: "(GMT+02:00) Europe Berlin",
    utc: "+02:00"
  },
  {
    label: "Europe/Bratislava (GMT+02:00)",
    tzCode: "Europe/Bratislava",
    name: "(GMT+02:00) Europe Bratislava",
    utc: "+02:00"
  },
  {
    label: "Europe/Brussels (GMT+02:00)",
    tzCode: "Europe/Brussels",
    name: "(GMT+02:00) Europe Brussels",
    utc: "+02:00"
  },
  {
    label: "Europe/Budapest (GMT+02:00)",
    tzCode: "Europe/Budapest",
    name: "(GMT+02:00) Europe Budapest",
    utc: "+02:00"
  },
  {
    label: "Europe/Busingen (GMT+02:00)",
    tzCode: "Europe/Busingen",
    name: "(GMT+02:00) Europe Busingen",
    utc: "+02:00"
  },
  {
    label: "Europe/Copenhagen (GMT+02:00)",
    tzCode: "Europe/Copenhagen",
    name: "(GMT+02:00) Europe Copenhagen",
    utc: "+02:00"
  },
  {
    label: "Europe/Gibraltar (GMT+02:00)",
    tzCode: "Europe/Gibraltar",
    name: "(GMT+02:00) Europe Gibraltar",
    utc: "+02:00"
  },
  {
    label: "Europe/Kaliningrad (GMT+02:00)",
    tzCode: "Europe/Kaliningrad",
    name: "(GMT+02:00) Europe Kaliningrad",
    utc: "+02:00"
  },
  {
    label: "Europe/Ljubljana (GMT+02:00)",
    tzCode: "Europe/Ljubljana",
    name: "(GMT+02:00) Europe Ljubljana",
    utc: "+02:00"
  },
  {
    label: "Europe/Luxembourg (GMT+02:00)",
    tzCode: "Europe/Luxembourg",
    name: "(GMT+02:00) Europe Luxembourg",
    utc: "+02:00"
  },
  {
    label: "Europe/Madrid (GMT+02:00)",
    tzCode: "Europe/Madrid",
    name: "(GMT+02:00) Europe Madrid",
    utc: "+02:00"
  },
  {
    label: "Europe/Malta (GMT+02:00)",
    tzCode: "Europe/Malta",
    name: "(GMT+02:00) Europe Malta",
    utc: "+02:00"
  },
  {
    label: "Europe/Monaco (GMT+02:00)",
    tzCode: "Europe/Monaco",
    name: "(GMT+02:00) Europe Monaco",
    utc: "+02:00"
  },
  {
    label: "Europe/Oslo (GMT+02:00)",
    tzCode: "Europe/Oslo",
    name: "(GMT+02:00) Europe Oslo",
    utc: "+02:00"
  },
  {
    label: "Europe/Paris (GMT+02:00)",
    tzCode: "Europe/Paris",
    name: "(GMT+02:00) Europe Paris",
    utc: "+02:00"
  },
  {
    label: "Europe/Podgorica (GMT+02:00)",
    tzCode: "Europe/Podgorica",
    name: "(GMT+02:00) Europe Podgorica",
    utc: "+02:00"
  },
  {
    label: "Europe/Prague (GMT+02:00)",
    tzCode: "Europe/Prague",
    name: "(GMT+02:00) Europe Prague",
    utc: "+02:00"
  },
  {
    label: "Europe/Rome (GMT+02:00)",
    tzCode: "Europe/Rome",
    name: "(GMT+02:00) Europe Rome",
    utc: "+02:00"
  },
  {
    label: "Europe/San Marino (GMT+02:00)",
    tzCode: "Europe/San_Marino",
    name: "(GMT+02:00) Europe San Marino",
    utc: "+02:00"
  },
  {
    label: "Europe/Sarajevo (GMT+02:00)",
    tzCode: "Europe/Sarajevo",
    name: "(GMT+02:00) Europe Sarajevo",
    utc: "+02:00"
  },
  {
    label: "Europe/Skopje (GMT+02:00)",
    tzCode: "Europe/Skopje",
    name: "(GMT+02:00) Europe Skopje",
    utc: "+02:00"
  },
  {
    label: "Europe/Stockholm (GMT+02:00)",
    tzCode: "Europe/Stockholm",
    name: "(GMT+02:00) Europe Stockholm",
    utc: "+02:00"
  },
  {
    label: "Europe/Tirane (GMT+02:00)",
    tzCode: "Europe/Tirane",
    name: "(GMT+02:00) Europe Tirane",
    utc: "+02:00"
  },
  {
    label: "Europe/Vaduz (GMT+02:00)",
    tzCode: "Europe/Vaduz",
    name: "(GMT+02:00) Europe Vaduz",
    utc: "+02:00"
  },
  {
    label: "Europe/Vatican (GMT+02:00)",
    tzCode: "Europe/Vatican",
    name: "(GMT+02:00) Europe Vatican",
    utc: "+02:00"
  },
  {
    label: "Europe/Vienna (GMT+02:00)",
    tzCode: "Europe/Vienna",
    name: "(GMT+02:00) Europe Vienna",
    utc: "+02:00"
  },
  {
    label: "Europe/Warsaw (GMT+02:00)",
    tzCode: "Europe/Warsaw",
    name: "(GMT+02:00) Europe Warsaw",
    utc: "+02:00"
  },
  {
    label: "Europe/Zagreb (GMT+02:00)",
    tzCode: "Europe/Zagreb",
    name: "(GMT+02:00) Europe Zagreb",
    utc: "+02:00"
  },
  {
    label: "Europe/Zurich (GMT+02:00)",
    tzCode: "Europe/Zurich",
    name: "(GMT+02:00) Europe Zurich",
    utc: "+02:00"
  },
  {
    label: "MET (GMT+02:00)",
    tzCode: "MET",
    name: "(GMT+02:00) MET",
    utc: "+02:00"
  },
  {
    label: "Africa/Addis Ababa (GMT+03:00)",
    tzCode: "Africa/Addis_Ababa",
    name: "(GMT+03:00) Africa Addis Ababa",
    utc: "+03:00"
  },
  {
    label: "Africa/Asmara (GMT+03:00)",
    tzCode: "Africa/Asmara",
    name: "(GMT+03:00) Africa Asmara",
    utc: "+03:00"
  },
  {
    label: "Africa/Dar es_Salaam (GMT+03:00)",
    tzCode: "Africa/Dar_es_Salaam",
    name: "(GMT+03:00) Africa Dar es Salaam",
    utc: "+03:00"
  },
  {
    label: "Africa/Djibouti (GMT+03:00)",
    tzCode: "Africa/Djibouti",
    name: "(GMT+03:00) Africa Djibouti",
    utc: "+03:00"
  },
  {
    label: "Africa/Kampala (GMT+03:00)",
    tzCode: "Africa/Kampala",
    name: "(GMT+03:00) Africa Kampala",
    utc: "+03:00"
  },
  {
    label: "Africa/Mogadishu (GMT+03:00)",
    tzCode: "Africa/Mogadishu",
    name: "(GMT+03:00) Africa Mogadishu",
    utc: "+03:00"
  },
  {
    label: "Africa/Nairobi (GMT+03:00)",
    tzCode: "Africa/Nairobi",
    name: "(GMT+03:00) Africa Nairobi",
    utc: "+03:00"
  },
  {
    label: "Antarctica/Syowa (GMT+03:00)",
    tzCode: "Antarctica/Syowa",
    name: "(GMT+03:00) Antarctica Syowa",
    utc: "+03:00"
  },
  {
    label: "Asia/Aden (GMT+03:00)",
    tzCode: "Asia/Aden",
    name: "(GMT+03:00) Asia Aden",
    utc: "+03:00"
  },
  {
    label: "Asia/Amman (GMT+03:00)",
    tzCode: "Asia/Amman",
    name: "(GMT+03:00) Asia Amman",
    utc: "+03:00"
  },
  {
    label: "Asia/Baghdad (GMT+03:00)",
    tzCode: "Asia/Baghdad",
    name: "(GMT+03:00) Asia Baghdad",
    utc: "+03:00"
  },
  {
    label: "Asia/Bahrain (GMT+03:00)",
    tzCode: "Asia/Bahrain",
    name: "(GMT+03:00) Asia Bahrain",
    utc: "+03:00"
  },
  {
    label: "Asia/Beirut (GMT+03:00)",
    tzCode: "Asia/Beirut",
    name: "(GMT+03:00) Asia Beirut",
    utc: "+03:00"
  },
  {
    label: "Asia/Damascus (GMT+03:00)",
    tzCode: "Asia/Damascus",
    name: "(GMT+03:00) Asia Damascus",
    utc: "+03:00"
  },
  {
    label: "Asia/Famagusta (GMT+03:00)",
    tzCode: "Asia/Famagusta",
    name: "(GMT+03:00) Asia Famagusta",
    utc: "+03:00"
  },
  {
    label: "Asia/Gaza (GMT+03:00)",
    tzCode: "Asia/Gaza",
    name: "(GMT+03:00) Asia Gaza",
    utc: "+03:00"
  },
  {
    label: "Asia/Hebron (GMT+03:00)",
    tzCode: "Asia/Hebron",
    name: "(GMT+03:00) Asia Hebron",
    utc: "+03:00"
  },
  {
    label: "Asia/Istanbul (GMT+03:00)",
    tzCode: "Asia/Istanbul",
    name: "(GMT+03:00) Asia Istanbul",
    utc: "+03:00"
  },
  {
    label: "Asia/Jerusalem (GMT+03:00)",
    tzCode: "Asia/Jerusalem",
    name: "(GMT+03:00) Asia Jerusalem",
    utc: "+03:00"
  },
  {
    label: "Asia/Kuwait (GMT+03:00)",
    tzCode: "Asia/Kuwait",
    name: "(GMT+03:00) Asia Kuwait",
    utc: "+03:00"
  },
  {
    label: "Asia/Nicosia (GMT+03:00)",
    tzCode: "Asia/Nicosia",
    name: "(GMT+03:00) Asia Nicosia",
    utc: "+03:00"
  },
  {
    label: "Asia/Qatar (GMT+03:00)",
    tzCode: "Asia/Qatar",
    name: "(GMT+03:00) Asia Qatar",
    utc: "+03:00"
  },
  {
    label: "Asia/Riyadh (GMT+03:00)",
    tzCode: "Asia/Riyadh",
    name: "(GMT+03:00) Asia Riyadh",
    utc: "+03:00"
  },
  {
    label: "EET (GMT+03:00)",
    tzCode: "EET",
    name: "(GMT+03:00) EET",
    utc: "+03:00"
  },
  {
    label: "Etc/GMT-3 (GMT+03:00)",
    tzCode: "Etc/GMT_3",
    name: "(GMT+03:00) Etc GMT-3",
    utc: "+03:00"
  },
  {
    label: "Europe/Athens (GMT+03:00)",
    tzCode: "Europe/Athens",
    name: "(GMT+03:00) Europe Athens",
    utc: "+03:00"
  },
  {
    label: "Europe/Bucharest (GMT+03:00)",
    tzCode: "Europe/Bucharest",
    name: "(GMT+03:00) Europe Bucharest",
    utc: "+03:00"
  },
  {
    label: "Europe/Chisinau (GMT+03:00)",
    tzCode: "Europe/Chisinau",
    name: "(GMT+03:00) Europe Chisinau",
    utc: "+03:00"
  },
  {
    label: "Europe/Helsinki (GMT+03:00)",
    tzCode: "Europe/Helsinki",
    name: "(GMT+03:00) Europe Helsinki",
    utc: "+03:00"
  },
  {
    label: "Europe/Istanbul (GMT+03:00)",
    tzCode: "Europe/Istanbul",
    name: "(GMT+03:00) Europe Istanbul",
    utc: "+03:00"
  },
  {
    label: "Europe/Kiev (GMT+03:00)",
    tzCode: "Europe/Kiev",
    name: "(GMT+03:00) Europe Kiev",
    utc: "+03:00"
  },
  {
    label: "Europe/Kirov (GMT+03:00)",
    tzCode: "Europe/Kirov",
    name: "(GMT+03:00) Europe Kirov",
    utc: "+03:00"
  },
  {
    label: "Europe/Mariehamn (GMT+03:00)",
    tzCode: "Europe/Mariehamn",
    name: "(GMT+03:00) Europe Mariehamn",
    utc: "+03:00"
  },
  {
    label: "Europe/Minsk (GMT+03:00)",
    tzCode: "Europe/Minsk",
    name: "(GMT+03:00) Europe Minsk",
    utc: "+03:00"
  },
  {
    label: "Europe/Moscow (GMT+03:00)",
    tzCode: "Europe/Moscow",
    name: "(GMT+03:00) Europe Moscow",
    utc: "+03:00"
  },
  {
    label: "Europe/Nicosia (GMT+03:00)",
    tzCode: "Europe/Nicosia",
    name: "(GMT+03:00) Europe Nicosia",
    utc: "+03:00"
  },
  {
    label: "Europe/Riga (GMT+03:00)",
    tzCode: "Europe/Riga",
    name: "(GMT+03:00) Europe Riga",
    utc: "+03:00"
  },
  {
    label: "Europe/Simferopol (GMT+03:00)",
    tzCode: "Europe/Simferopol",
    name: "(GMT+03:00) Europe Simferopol",
    utc: "+03:00"
  },
  {
    label: "Europe/Sofia (GMT+03:00)",
    tzCode: "Europe/Sofia",
    name: "(GMT+03:00) Europe Sofia",
    utc: "+03:00"
  },
  {
    label: "Europe/Tallinn (GMT+03:00)",
    tzCode: "Europe/Tallinn",
    name: "(GMT+03:00) Europe Tallinn",
    utc: "+03:00"
  },
  {
    label: "Europe/Uzhgorod (GMT+03:00)",
    tzCode: "Europe/Uzhgorod",
    name: "(GMT+03:00) Europe Uzhgorod",
    utc: "+03:00"
  },
  {
    label: "Europe/Vilnius (GMT+03:00)",
    tzCode: "Europe/Vilnius",
    name: "(GMT+03:00) Europe Vilnius",
    utc: "+03:00"
  },
  {
    label: "Europe/Volgograd (GMT+03:00)",
    tzCode: "Europe/Volgograd",
    name: "(GMT+03:00) Europe Volgograd",
    utc: "+03:00"
  },
  {
    label: "Europe/Zaporozhye (GMT+03:00)",
    tzCode: "Europe/Zaporozhye",
    name: "(GMT+03:00) Europe Zaporozhye",
    utc: "+03:00"
  },
  {
    label: "Indian/Antananarivo (GMT+03:00)",
    tzCode: "Indian/Antananarivo",
    name: "(GMT+03:00) Indian Antananarivo",
    utc: "+03:00"
  },
  {
    label: "Indian/Comoro (GMT+03:00)",
    tzCode: "Indian/Comoro",
    name: "(GMT+03:00) Indian Comoro",
    utc: "+03:00"
  },
  {
    label: "Indian/Mayotte (GMT+03:00)",
    tzCode: "Indian/Mayotte",
    name: "(GMT+03:00) Indian Mayotte",
    utc: "+03:00"
  },
  {
    label: "Asia/Baku (GMT+04:00)",
    tzCode: "Asia/Baku",
    name: "(GMT+04:00) Asia Baku",
    utc: "+04:00"
  },
  {
    label: "Asia/Dubai (GMT+04:00)",
    tzCode: "Asia/Dubai",
    name: "(GMT+04:00) Asia Dubai",
    utc: "+04:00"
  },
  {
    label: "Asia/Muscat (GMT+04:00)",
    tzCode: "Asia/Muscat",
    name: "(GMT+04:00) Asia Muscat",
    utc: "+04:00"
  },
  {
    label: "Asia/Tbilisi (GMT+04:00)",
    tzCode: "Asia/Tbilisi",
    name: "(GMT+04:00) Asia Tbilisi",
    utc: "+04:00"
  },
  {
    label: "Asia/Yerevan (GMT+04:00)",
    tzCode: "Asia/Yerevan",
    name: "(GMT+04:00) Asia Yerevan",
    utc: "+04:00"
  },
  {
    label: "Etc/GMT-4 (GMT+04:00)",
    tzCode: "Etc/GMT_4",
    name: "(GMT+04:00) Etc GMT-4",
    utc: "+04:00"
  },
  {
    label: "Europe/Astrakhan (GMT+04:00)",
    tzCode: "Europe/Astrakhan",
    name: "(GMT+04:00) Europe Astrakhan",
    utc: "+04:00"
  },
  {
    label: "Europe/Samara (GMT+04:00)",
    tzCode: "Europe/Samara",
    name: "(GMT+04:00) Europe Samara",
    utc: "+04:00"
  },
  {
    label: "Europe/Saratov (GMT+04:00)",
    tzCode: "Europe/Saratov",
    name: "(GMT+04:00) Europe Saratov",
    utc: "+04:00"
  },
  {
    label: "Europe/Ulyanovsk (GMT+04:00)",
    tzCode: "Europe/Ulyanovsk",
    name: "(GMT+04:00) Europe Ulyanovsk",
    utc: "+04:00"
  },
  {
    label: "Indian/Mahe (GMT+04:00)",
    tzCode: "Indian/Mahe",
    name: "(GMT+04:00) Indian Mahe",
    utc: "+04:00"
  },
  {
    label: "Indian/Mauritius (GMT+04:00)",
    tzCode: "Indian/Mauritius",
    name: "(GMT+04:00) Indian Mauritius",
    utc: "+04:00"
  },
  {
    label: "Indian/Reunion (GMT+04:00)",
    tzCode: "Indian/Reunion",
    name: "(GMT+04:00) Indian Reunion",
    utc: "+04:00"
  },
  {
    label: "Asia/Kabul (GMT+04:30)",
    tzCode: "Asia/Kabul",
    name: "(GMT+04:30) Asia Kabul",
    utc: "+04:30"
  },
  {
    label: "Asia/Tehran (GMT+04:30)",
    tzCode: "Asia/Tehran",
    name: "(GMT+04:30) Asia Tehran",
    utc: "+04:30"
  },
  {
    label: "Antarctica/Mawson (GMT+05:00)",
    tzCode: "Antarctica/Mawson",
    name: "(GMT+05:00) Antarctica Mawson",
    utc: "+05:00"
  },
  {
    label: "Asia/Aqtau (GMT+05:00)",
    tzCode: "Asia/Aqtau",
    name: "(GMT+05:00) Asia Aqtau",
    utc: "+05:00"
  },
  {
    label: "Asia/Aqtobe (GMT+05:00)",
    tzCode: "Asia/Aqtobe",
    name: "(GMT+05:00) Asia Aqtobe",
    utc: "+05:00"
  },
  {
    label: "Asia/Ashgabat (GMT+05:00)",
    tzCode: "Asia/Ashgabat",
    name: "(GMT+05:00) Asia Ashgabat",
    utc: "+05:00"
  },
  {
    label: "Asia/Atyrau (GMT+05:00)",
    tzCode: "Asia/Atyrau",
    name: "(GMT+05:00) Asia Atyrau",
    utc: "+05:00"
  },
  {
    label: "Asia/Dushanbe (GMT+05:00)",
    tzCode: "Asia/Dushanbe",
    name: "(GMT+05:00) Asia Dushanbe",
    utc: "+05:00"
  },
  {
    label: "Asia/Karachi (GMT+05:00)",
    tzCode: "Asia/Karachi",
    name: "(GMT+05:00) Asia Karachi",
    utc: "+05:00"
  },
  {
    label: "Asia/Oral (GMT+05:00)",
    tzCode: "Asia/Oral",
    name: "(GMT+05:00) Asia Oral",
    utc: "+05:00"
  },
  {
    label: "Asia/Qyzylorda (GMT+05:00)",
    tzCode: "Asia/Qyzylorda",
    name: "(GMT+05:00) Asia Qyzylorda",
    utc: "+05:00"
  },
  {
    label: "Asia/Samarkand (GMT+05:00)",
    tzCode: "Asia/Samarkand",
    name: "(GMT+05:00) Asia Samarkand",
    utc: "+05:00"
  },
  {
    label: "Asia/Tashkent (GMT+05:00)",
    tzCode: "Asia/Tashkent",
    name: "(GMT+05:00) Asia Tashkent",
    utc: "+05:00"
  },
  {
    label: "Asia/Yekaterinburg (GMT+05:00)",
    tzCode: "Asia/Yekaterinburg",
    name: "(GMT+05:00) Asia Yekaterinburg",
    utc: "+05:00"
  },
  {
    label: "Etc/GMT-5 (GMT+05:00)",
    tzCode: "Etc/GMT_5",
    name: "(GMT+05:00) Etc GMT-5",
    utc: "+05:00"
  },
  {
    label: "Indian/Kerguelen (GMT+05:00)",
    tzCode: "Indian/Kerguelen",
    name: "(GMT+05:00) Indian Kerguelen",
    utc: "+05:00"
  },
  {
    label: "Indian/Maldives (GMT+05:00)",
    tzCode: "Indian/Maldives",
    name: "(GMT+05:00) Indian Maldives",
    utc: "+05:00"
  },
  {
    label: "Asia/Calcutta (GMT+05:30)",
    tzCode: "Asia/Calcutta",
    name: "(GMT+05:30) Asia Calcutta",
    utc: "+05:30"
  },
  {
    label: "Asia/Colombo (GMT+05:30)",
    tzCode: "Asia/Colombo",
    name: "(GMT+05:30) Asia Colombo",
    utc: "+05:30"
  },
  {
    label: "Asia/Kolkata (GMT+05:30)",
    tzCode: "Asia/Kolkata",
    name: "(GMT+05:30) Asia Kolkata",
    utc: "+05:30"
  },
  {
    label: "Asia/Kathmandu (GMT+05:45)",
    tzCode: "Asia/Kathmandu",
    name: "(GMT+05:45) Asia Kathmandu",
    utc: "+05:45"
  },
  {
    label: "Asia/Katmandu (GMT+05:45)",
    tzCode: "Asia/Katmandu",
    name: "(GMT+05:45) Asia Katmandu",
    utc: "+05:45"
  },
  {
    label: "Antarctica/Vostok (GMT+06:00)",
    tzCode: "Antarctica/Vostok",
    name: "(GMT+06:00) Antarctica Vostok",
    utc: "+06:00"
  },
  {
    label: "Asia/Almaty (GMT+06:00)",
    tzCode: "Asia/Almaty",
    name: "(GMT+06:00) Asia Almaty",
    utc: "+06:00"
  },
  {
    label: "Asia/Bishkek (GMT+06:00)",
    tzCode: "Asia/Bishkek",
    name: "(GMT+06:00) Asia Bishkek",
    utc: "+06:00"
  },
  {
    label: "Asia/Dhaka (GMT+06:00)",
    tzCode: "Asia/Dhaka",
    name: "(GMT+06:00) Asia Dhaka",
    utc: "+06:00"
  },
  {
    label: "Asia/Omsk (GMT+06:00)",
    tzCode: "Asia/Omsk",
    name: "(GMT+06:00) Asia Omsk",
    utc: "+06:00"
  },
  {
    label: "Asia/Qostanay (GMT+06:00)",
    tzCode: "Asia/Qostanay",
    name: "(GMT+06:00) Asia Qostanay",
    utc: "+06:00"
  },
  {
    label: "Asia/Thimphu (GMT+06:00)",
    tzCode: "Asia/Thimphu",
    name: "(GMT+06:00) Asia Thimphu",
    utc: "+06:00"
  },
  {
    label: "Asia/Urumqi (GMT+06:00)",
    tzCode: "Asia/Urumqi",
    name: "(GMT+06:00) Asia Urumqi",
    utc: "+06:00"
  },
  {
    label: "Etc/GMT-6 (GMT+06:00)",
    tzCode: "Etc/GMT_6",
    name: "(GMT+06:00) Etc GMT-6",
    utc: "+06:00"
  },
  {
    label: "Indian/Chagos (GMT+06:00)",
    tzCode: "Indian/Chagos",
    name: "(GMT+06:00) Indian Chagos",
    utc: "+06:00"
  },
  {
    label: "Asia/Yangon (GMT+06:30)",
    tzCode: "Asia/Yangon",
    name: "(GMT+06:30) Asia Yangon",
    utc: "+06:30"
  },
  {
    label: "Indian/Cocos (GMT+06:30)",
    tzCode: "Indian/Cocos",
    name: "(GMT+06:30) Indian Cocos",
    utc: "+06:30"
  },
  {
    label: "Antarctica/Davis (GMT+07:00)",
    tzCode: "Antarctica/Davis",
    name: "(GMT+07:00) Antarctica Davis",
    utc: "+07:00"
  },
  {
    label: "Asia/Bangkok (GMT+07:00)",
    tzCode: "Asia/Bangkok",
    name: "(GMT+07:00) Asia Bangkok",
    utc: "+07:00"
  },
  {
    label: "Asia/Barnaul (GMT+07:00)",
    tzCode: "Asia/Barnaul",
    name: "(GMT+07:00) Asia Barnaul",
    utc: "+07:00"
  },
  {
    label: "Asia/Ho Chi_Minh (GMT+07:00)",
    tzCode: "Asia/Ho_Chi_Minh",
    name: "(GMT+07:00) Asia Ho Chi Minh",
    utc: "+07:00"
  },
  {
    label: "Asia/Hovd (GMT+07:00)",
    tzCode: "Asia/Hovd",
    name: "(GMT+07:00) Asia Hovd",
    utc: "+07:00"
  },
  {
    label: "Asia/Jakarta (GMT+07:00)",
    tzCode: "Asia/Jakarta",
    name: "(GMT+07:00) Asia Jakarta",
    utc: "+07:00"
  },
  {
    label: "Asia/Krasnoyarsk (GMT+07:00)",
    tzCode: "Asia/Krasnoyarsk",
    name: "(GMT+07:00) Asia Krasnoyarsk",
    utc: "+07:00"
  },
  {
    label: "Asia/Novokuznetsk (GMT+07:00)",
    tzCode: "Asia/Novokuznetsk",
    name: "(GMT+07:00) Asia Novokuznetsk",
    utc: "+07:00"
  },
  {
    label: "Asia/Novosibirsk (GMT+07:00)",
    tzCode: "Asia/Novosibirsk",
    name: "(GMT+07:00) Asia Novosibirsk",
    utc: "+07:00"
  },
  {
    label: "Asia/Phnom Penh (GMT+07:00)",
    tzCode: "Asia/Phnom_Penh",
    name: "(GMT+07:00) Asia Phnom Penh",
    utc: "+07:00"
  },
  {
    label: "Asia/Pontianak (GMT+07:00)",
    tzCode: "Asia/Pontianak",
    name: "(GMT+07:00) Asia Pontianak",
    utc: "+07:00"
  },
  {
    label: "Asia/Tomsk (GMT+07:00)",
    tzCode: "Asia/Tomsk",
    name: "(GMT+07:00) Asia Tomsk",
    utc: "+07:00"
  },
  {
    label: "Asia/Vientiane (GMT+07:00)",
    tzCode: "Asia/Vientiane",
    name: "(GMT+07:00) Asia Vientiane",
    utc: "+07:00"
  },
  {
    label: "Etc/GMT-7 (GMT+07:00)",
    tzCode: "Etc/GMT_7",
    name: "(GMT+07:00) Etc GMT-7",
    utc: "+07:00"
  },
  {
    label: "Indian/Christmas (GMT+07:00)",
    tzCode: "Indian/Christmas",
    name: "(GMT+07:00) Indian Christmas",
    utc: "+07:00"
  },
  {
    label: "Asia/Brunei (GMT+08:00)",
    tzCode: "Asia/Brunei",
    name: "(GMT+08:00) Asia Brunei",
    utc: "+08:00"
  },
  {
    label: "Asia/Choibalsan (GMT+08:00)",
    tzCode: "Asia/Choibalsan",
    name: "(GMT+08:00) Asia Choibalsan",
    utc: "+08:00"
  },
  {
    label: "Asia/Hong Kong (GMT+08:00)",
    tzCode: "Asia/Hong_Kong",
    name: "(GMT+08:00) Asia Hong Kong",
    utc: "+08:00"
  },
  {
    label: "Asia/Irkutsk (GMT+08:00)",
    tzCode: "Asia/Irkutsk",
    name: "(GMT+08:00) Asia Irkutsk",
    utc: "+08:00"
  },
  {
    label: "Asia/Kuala Lumpur (GMT+08:00)",
    tzCode: "Asia/Kuala_Lumpur",
    name: "(GMT+08:00) Asia Kuala Lumpur",
    utc: "+08:00"
  },
  {
    label: "Asia/Kuching (GMT+08:00)",
    tzCode: "Asia/Kuching",
    name: "(GMT+08:00) Asia Kuching",
    utc: "+08:00"
  },
  {
    label: "Asia/Macau (GMT+08:00)",
    tzCode: "Asia/Macau",
    name: "(GMT+08:00) Asia Macau",
    utc: "+08:00"
  },
  {
    label: "Asia/Makassar (GMT+08:00)",
    tzCode: "Asia/Makassar",
    name: "(GMT+08:00) Asia Makassar",
    utc: "+08:00"
  },
  {
    label: "Asia/Manila (GMT+08:00)",
    tzCode: "Asia/Manila",
    name: "(GMT+08:00) Asia Manila",
    utc: "+08:00"
  },
  {
    label: "Asia/Shanghai (GMT+08:00)",
    tzCode: "Asia/Shanghai",
    name: "(GMT+08:00) Asia Shanghai",
    utc: "+08:00"
  },
  {
    label: "Asia/Taipei (GMT+08:00)",
    tzCode: "Asia/Taipei",
    name: "(GMT+08:00) Asia Taipei",
    utc: "+08:00"
  },
  {
    label: "Asia/Ulaanbaatar (GMT+08:00)",
    tzCode: "Asia/Ulaanbaatar",
    name: "(GMT+08:00) Asia Ulaanbaatar",
    utc: "+08:00"
  },
  {
    label: "Australia/Perth (GMT+08:00)",
    tzCode: "Australia/Perth",
    name: "(GMT+08:00) Australia Perth",
    utc: "+08:00"
  },
  {
    label: "Etc/GMT-8 (GMT+08:00)",
    tzCode: "Etc/GMT_8",
    name: "(GMT+08:00) Etc GMT-8",
    utc: "+08:00"
  },
  {
    label: "Australia/Eucla (GMT+08:45)",
    tzCode: "Australia/Eucla",
    name: "(GMT+08:45) Australia Eucla",
    utc: "+08:45"
  },
  {
    label: "Asia/Chita (GMT+09:00)",
    tzCode: "Asia/Chita",
    name: "(GMT+09:00) Asia Chita",
    utc: "+09:00"
  },
  {
    label: "Asia/Dili (GMT+09:00)",
    tzCode: "Asia/Dili",
    name: "(GMT+09:00) Asia Dili",
    utc: "+09:00"
  },
  {
    label: "Asia/Jayapura (GMT+09:00)",
    tzCode: "Asia/Jayapura",
    name: "(GMT+09:00) Asia Jayapura",
    utc: "+09:00"
  },
  {
    label: "Asia/Khandyga (GMT+09:00)",
    tzCode: "Asia/Khandyga",
    name: "(GMT+09:00) Asia Khandyga",
    utc: "+09:00"
  },
  {
    label: "Asia/Pyongyang (GMT+09:00)",
    tzCode: "Asia/Pyongyang",
    name: "(GMT+09:00) Asia Pyongyang",
    utc: "+09:00"
  },
  {
    label: "Asia/Seoul (GMT+09:00)",
    tzCode: "Asia/Seoul",
    name: "(GMT+09:00) Asia Seoul",
    utc: "+09:00"
  },
  {
    label: "Asia/Tokyo (GMT+09:00)",
    tzCode: "Asia/Tokyo",
    name: "(GMT+09:00) Asia Tokyo",
    utc: "+09:00"
  },
  {
    label: "Asia/Yakutsk (GMT+09:00)",
    tzCode: "Asia/Yakutsk",
    name: "(GMT+09:00) Asia Yakutsk",
    utc: "+09:00"
  },
  {
    label: "Etc/GMT-9 (GMT+09:00)",
    tzCode: "Etc/GMT_9",
    name: "(GMT+09:00) Etc GMT-9",
    utc: "+09:00"
  },
  {
    label: "Pacific/Palau (GMT+09:00)",
    tzCode: "Pacific/Palau",
    name: "(GMT+09:00) Pacific Palau",
    utc: "+09:00"
  },
  {
    label: "Australia/Adelaide (GMT+09:30)",
    tzCode: "Australia/Adelaide",
    name: "(GMT+09:30) Australia Adelaide",
    utc: "+09:30"
  },
  {
    label: "Australia/Broken Hill (GMT+09:30)",
    tzCode: "Australia/Broken_Hill",
    name: "(GMT+09:30) Australia Broken Hill",
    utc: "+09:30"
  },
  {
    label: "Australia/Darwin (GMT+09:30)",
    tzCode: "Australia/Darwin",
    name: "(GMT+09:30) Australia Darwin",
    utc: "+09:30"
  },
  {
    label: "Antarctica/DumontDUrville (GMT+10:00)",
    tzCode: "Antarctica/DumontDUrville",
    name: "(GMT+10:00) Antarctica DumontDUrville",
    utc: "+10:00"
  },
  {
    label: "Antarctica/Macquarie (GMT+10:00)",
    tzCode: "Antarctica/Macquarie",
    name: "(GMT+10:00) Antarctica Macquarie",
    utc: "+10:00"
  },
  {
    label: "Asia/Ust-Nera (GMT+10:00)",
    tzCode: "Asia/Ust_Nera",
    name: "(GMT+10:00) Asia Ust-Nera",
    utc: "+10:00"
  },
  {
    label: "Asia/Vladivostok (GMT+10:00)",
    tzCode: "Asia/Vladivostok",
    name: "(GMT+10:00) Asia Vladivostok",
    utc: "+10:00"
  },
  {
    label: "Australia/Brisbane (GMT+10:00)",
    tzCode: "Australia/Brisbane",
    name: "(GMT+10:00) Australia Brisbane",
    utc: "+10:00"
  },
  {
    label: "Australia/Currie (GMT+10:00)",
    tzCode: "Australia/Currie",
    name: "(GMT+10:00) Australia Currie",
    utc: "+10:00"
  },
  {
    label: "Australia/Hobart (GMT+10:00)",
    tzCode: "Australia/Hobart",
    name: "(GMT+10:00) Australia Hobart",
    utc: "+10:00"
  },
  {
    label: "Australia/Lindeman (GMT+10:00)",
    tzCode: "Australia/Lindeman",
    name: "(GMT+10:00) Australia Lindeman",
    utc: "+10:00"
  },
  {
    label: "Australia/Melbourne (GMT+10:00)",
    tzCode: "Australia/Melbourne",
    name: "(GMT+10:00) Australia Melbourne",
    utc: "+10:00"
  },
  {
    label: "Australia/Sydney (GMT+10:00)",
    tzCode: "Australia/Sydney",
    name: "(GMT+10:00) Australia Sydney",
    utc: "+10:00"
  },
  {
    label: "Etc/GMT-10 (GMT+10:00)",
    tzCode: "Etc/GMT_10",
    name: "(GMT+10:00) Etc GMT-10",
    utc: "+10:00"
  },
  {
    label: "Pacific/Chuuk (GMT+10:00)",
    tzCode: "Pacific/Chuuk",
    name: "(GMT+10:00) Pacific Chuuk",
    utc: "+10:00"
  },
  {
    label: "Pacific/Guam (GMT+10:00)",
    tzCode: "Pacific/Guam",
    name: "(GMT+10:00) Pacific Guam",
    utc: "+10:00"
  },
  {
    label: "Pacific/Port Moresby (GMT+10:00)",
    tzCode: "Pacific/Port_Moresby",
    name: "(GMT+10:00) Pacific Port Moresby",
    utc: "+10:00"
  },
  {
    label: "Pacific/Saipan (GMT+10:00)",
    tzCode: "Pacific/Saipan",
    name: "(GMT+10:00) Pacific Saipan",
    utc: "+10:00"
  },
  {
    label: "Australia/Lord Howe (GMT+10:30)",
    tzCode: "Australia/Lord_Howe",
    name: "(GMT+10:30) Australia Lord Howe",
    utc: "+10:30"
  },
  {
    label: "Antarctica/Casey (GMT+11:00)",
    tzCode: "Antarctica/Casey",
    name: "(GMT+11:00) Antarctica Casey",
    utc: "+11:00"
  },
  {
    label: "Asia/Magadan (GMT+11:00)",
    tzCode: "Asia/Magadan",
    name: "(GMT+11:00) Asia Magadan",
    utc: "+11:00"
  },
  {
    label: "Asia/Sakhalin (GMT+11:00)",
    tzCode: "Asia/Sakhalin",
    name: "(GMT+11:00) Asia Sakhalin",
    utc: "+11:00"
  },
  {
    label: "Asia/Srednekolymsk (GMT+11:00)",
    tzCode: "Asia/Srednekolymsk",
    name: "(GMT+11:00) Asia Srednekolymsk",
    utc: "+11:00"
  },
  {
    label: "Etc/GMT-11 (GMT+11:00)",
    tzCode: "Etc/GMT_11",
    name: "(GMT+11:00) Etc GMT-11",
    utc: "+11:00"
  },
  {
    label: "Pacific/Bougainville (GMT+11:00)",
    tzCode: "Pacific/Bougainville",
    name: "(GMT+11:00) Pacific Bougainville",
    utc: "+11:00"
  },
  {
    label: "Pacific/Efate (GMT+11:00)",
    tzCode: "Pacific/Efate",
    name: "(GMT+11:00) Pacific Efate",
    utc: "+11:00"
  },
  {
    label: "Pacific/Guadalcanal (GMT+11:00)",
    tzCode: "Pacific/Guadalcanal",
    name: "(GMT+11:00) Pacific Guadalcanal",
    utc: "+11:00"
  },
  {
    label: "Pacific/Kosrae (GMT+11:00)",
    tzCode: "Pacific/Kosrae",
    name: "(GMT+11:00) Pacific Kosrae",
    utc: "+11:00"
  },
  {
    label: "Pacific/Norfolk (GMT+11:00)",
    tzCode: "Pacific/Norfolk",
    name: "(GMT+11:00) Pacific Norfolk",
    utc: "+11:00"
  },
  {
    label: "Pacific/Noumea (GMT+11:00)",
    tzCode: "Pacific/Noumea",
    name: "(GMT+11:00) Pacific Noumea",
    utc: "+11:00"
  },
  {
    label: "Pacific/Pohnpei (GMT+11:00)",
    tzCode: "Pacific/Pohnpei",
    name: "(GMT+11:00) Pacific Pohnpei",
    utc: "+11:00"
  },
  {
    label: "Antarctica/McMurdo (GMT+12:00)",
    tzCode: "Antarctica/McMurdo",
    name: "(GMT+12:00) Antarctica McMurdo",
    utc: "+12:00"
  },
  {
    label: "Asia/Anadyr (GMT+12:00)",
    tzCode: "Asia/Anadyr",
    name: "(GMT+12:00) Asia Anadyr",
    utc: "+12:00"
  },
  {
    label: "Asia/Kamchatka (GMT+12:00)",
    tzCode: "Asia/Kamchatka",
    name: "(GMT+12:00) Asia Kamchatka",
    utc: "+12:00"
  },
  {
    label: "Etc/GMT-12 (GMT+12:00)",
    tzCode: "Etc/GMT_12",
    name: "(GMT+12:00) Etc GMT-12",
    utc: "+12:00"
  },
  {
    label: "Pacific/Auckland (GMT+12:00)",
    tzCode: "Pacific/Auckland",
    name: "(GMT+12:00) Pacific Auckland",
    utc: "+12:00"
  },
  {
    label: "Pacific/Fiji (GMT+12:00)",
    tzCode: "Pacific/Fiji",
    name: "(GMT+12:00) Pacific Fiji",
    utc: "+12:00"
  },
  {
    label: "Pacific/Funafuti (GMT+12:00)",
    tzCode: "Pacific/Funafuti",
    name: "(GMT+12:00) Pacific Funafuti",
    utc: "+12:00"
  },
  {
    label: "Pacific/Kwajalein (GMT+12:00)",
    tzCode: "Pacific/Kwajalein",
    name: "(GMT+12:00) Pacific Kwajalein",
    utc: "+12:00"
  },
  {
    label: "Pacific/Majuro (GMT+12:00)",
    tzCode: "Pacific/Majuro",
    name: "(GMT+12:00) Pacific Majuro",
    utc: "+12:00"
  },
  {
    label: "Pacific/Nauru (GMT+12:00)",
    tzCode: "Pacific/Nauru",
    name: "(GMT+12:00) Pacific Nauru",
    utc: "+12:00"
  },
  {
    label: "Pacific/Tarawa (GMT+12:00)",
    tzCode: "Pacific/Tarawa",
    name: "(GMT+12:00) Pacific Tarawa",
    utc: "+12:00"
  },
  {
    label: "Pacific/Wake (GMT+12:00)",
    tzCode: "Pacific/Wake",
    name: "(GMT+12:00) Pacific Wake",
    utc: "+12:00"
  },
  {
    label: "Pacific/Wallis (GMT+12:00)",
    tzCode: "Pacific/Wallis",
    name: "(GMT+12:00) Pacific Wallis",
    utc: "+12:00"
  },
  {
    label: "Pacific/Chatham (GMT+12:45)",
    tzCode: "Pacific/Chatham",
    name: "(GMT+12:45) Pacific Chatham",
    utc: "+12:45"
  },
  {
    label: "Etc/GMT-13 (GMT+13:00)",
    tzCode: "Etc/GMT_13",
    name: "(GMT+13:00) Etc GMT-13",
    utc: "+13:00"
  },
  {
    label: "Pacific/Apia (GMT+13:00)",
    tzCode: "Pacific/Apia",
    name: "(GMT+13:00) Pacific Apia",
    utc: "+13:00"
  },
  {
    label: "Pacific/Enderbury (GMT+13:00)",
    tzCode: "Pacific/Enderbury",
    name: "(GMT+13:00) Pacific Enderbury",
    utc: "+13:00"
  },
  {
    label: "Pacific/Fakaofo (GMT+13:00)",
    tzCode: "Pacific/Fakaofo",
    name: "(GMT+13:00) Pacific Fakaofo",
    utc: "+13:00"
  },
  {
    label: "Pacific/Tongatapu (GMT+13:00)",
    tzCode: "Pacific/Tongatapu",
    name: "(GMT+13:00) Pacific Tongatapu",
    utc: "+13:00"
  },
  {
    label: "Etc/GMT-14 (GMT+14:00)",
    tzCode: "Etc/GMT_14",
    name: "(GMT+14:00) Etc GMT-14",
    utc: "+14:00"
  },
  {
    label: "Pacific/Kiritimati (GMT+14:00)",
    tzCode: "Pacific/Kiritimati",
    name: "(GMT+14:00) Pacific Kiritimati",
    utc: "+14:00"
  }
]
